
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait, Random } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import mini from './cantidad-lista-mini.vue';
import { OpcionDePrecio } from '@/__env/lib/Articulos/Articulo.lib';
import { min } from 'moment';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            mini,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get Articulo()
        {
            return this.Controlador.EdicionPedido.NuevoItem.Articulo;
        }

        public Agregando: boolean = false;
        public AbrirPrecios: boolean = false;
        public Estado: 'cargando' | 'ok' | 'vacio' = 'ok';
        public Focused: boolean = false;
        public InputError: boolean = false;
        public InputErrorTimer: boolean = false;
        async onInputError()
        {
            this.Agregando = false;
            this.InputError = true;
            this.Busqueda = '';
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            this.InputError = false;

        }

        public Items: OpcionDePrecio[] = [];

        public Cantidad: number = 0;
        public ControlFraccion(): boolean
        {
            return this.Controlador.EdicionPedido.NuevoItem.ControlFraccion( this.Cantidad, this.Articulo );
        }

        public Seleccionado: number = -1;
        public Busqueda: string = '';
        @Watch( 'Busqueda', { immediate: true } )
        async onBusqueda()
        {
            if ( this.Busqueda )
            {
                this.Cantidad = Number( this.Busqueda );
            } else
            {
                this.Cantidad = this.Articulo.CantidadFraccion;
            }
        }

        public async Buscar( forzar?: boolean )
        {
            this.Estado = 'cargando';
            this.Items.clear();


            let e = await this.Articulo.cargarPrecios( this.Controlador.EdicionPedido.Tipo.Lista, null, this.Controlador.EdicionPedido.Cliente.Id );
            if ( !e.Error )
            {
                this.Items.clear();
                for ( let item of e.Items )
                {
                    if ( this.Articulo.Precio.SubTipo != item.SubTipo )
                    {
                        this.Items.push( item );
                    }
                }
            } else
            {
                this.Items.clear();
            }

            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';

        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            if ( !this.Articulo )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }
        }

        KeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }
        async KeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'Escape' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }
            else if ( e.key == 'ArrowUp' )
            {
                if ( this.Seleccionado <= 0 )
                {
                    this.AbrirPrecios = false;
                } else
                {
                    this.SeleccionarLista( this.Seleccionado - 1 );
                }
            }
            else if ( e.key == 'ArrowDown' )
            {
                if ( !this.AbrirPrecios )
                {
                    this.AbrirPrecios = true;
                    await this.Buscar();
                } else
                {
                    this.SeleccionarLista( this.Seleccionado + 1 );
                }
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items[this.Seleccionado] )
                {
                    let itm = this.Items[this.Seleccionado];
                    if ( await this.Articulo.cargarPrecio( itm.Tipo, null, this.Controlador.EdicionPedido.Cliente.Id, itm.SubTipo, itm.Id ) )
                    {
                        this.Items.clear();
                        this.Seleccionado = -1;
                        this.AbrirPrecios = false;
                    }
                } else
                {
                    if ( !this.ControlFraccion() )
                    {
                        this.onInputError();
                    } else
                    {
                        this.Agregar( this.Cantidad );
                    }
                }

            }


        }

        public async Agregar( x: number )
        {
            this.Agregando = true;

            let e = await this.Controlador.EdicionPedido.NuevoItem.Agregar( this.Articulo, x );
            if ( e.Resultado )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            } else
            {
                this.Agregando = false;
                this.onInputError();
            }

        }


        public SeleccionarLista( x: number )
        {
            if ( this.Items[x] )
            {
                this.Seleccionado = x;
                if ( !this.isVisibleListaMini( this.Seleccionado ) )
                    this.ScrollToItemListaMini();
            }
        }

        protected ScrollToItemListaMini()
        {
            let element = document.getElementById( 'barra-izquierda-lista-mini' );
            let element2 = document.getElementById( 'barra-izquierda-lista-mini-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 60,
                duration: 0,
            } );
        }

        protected isVisibleListaMini( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-mini-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista-mini' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }
    }
